import './Base'
/** @namespace UI.Widget.Forms.Control */
NS("UI.Widget.Forms.Control");

/**
 * @class
 * @extends UI.Widget.Forms.Control.Base
 */
UI.Widget.Forms.Control.Hr = Class(UI.Widget.Forms.Control.Element, /** @lends UI.Widget.Forms.Control.Hr.prototype */ {
    createElement: function() {
        this.$element = $("<hr>");
        return this
    },
});
